__turbopack_context__.v({
  "dark-mode": "mochi-carousel-indicator-module-scss-module__Y8Kg1q__dark-mode",
  "indicator": "mochi-carousel-indicator-module-scss-module__Y8Kg1q__indicator",
  "indicator-group": "mochi-carousel-indicator-module-scss-module__Y8Kg1q__indicator-group",
  "indicator-line": "mochi-carousel-indicator-module-scss-module__Y8Kg1q__indicator-line",
  "inside": "mochi-carousel-indicator-module-scss-module__Y8Kg1q__inside",
  "marker": "mochi-carousel-indicator-module-scss-module__Y8Kg1q__marker",
});
